import { useCallback, useEffect, useRef, useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import LeroyMerlinService from '../../../services/database/LeroyMerlinService'
import { CustomButton } from '../../../components/CustomButton'
import Select from 'react-select'

import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import { CustomSpinner } from '../../../components/CustomSpinner'
import { ProductCard } from './ProductCard'
import { useProducts } from '../../../hooks/useProducts'
import { FiletypeXlsx, Shop, HandIndexThumbFill } from 'react-bootstrap-icons'

import './styles.css'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

export function ModalExpLeroy({ isOpen, onClose }) {
  const [hierarchies, setHierarchies] = useState([])
  const [hierarchySelected, setHierarchySelected] = useState('')
  const [hierarchyIsLoading, setHierarchyIsLoading] = useState(false)
  const [isButtonGenerateFileLoading, setIsButtonGenerateFileLoading] =
    useState(false)
  const [fileSelected, setFileSelected] = useState()
  const [isSendStoreLoading, setIsSendStoreLoading] = useState(false)
  const [accounts, setAccounts] = useState([])
  const [selectedAccountKey, setSelectedAccountKey] = useState('')

  const generateFileButtonRef = useRef()
  const linkDownloadRef = useRef(null)

  const { productsToExport, resetProducts } = useProducts()

  async function getAccounts() {
    try {
      const accountsData = await LeroyMerlinService.getAccounts()

      setAccounts(accountsData)
    } catch (err) {
      console.log(err)
    }
  }

  const getHierarchies = useCallback(async (apiLeroyKey) => {
    setHierarchyIsLoading(true)

    try {
      const data = await LeroyMerlinService.getHierarchies(apiLeroyKey)

      console.log(data)

      const dataSorted = data.toSorted((a, b) => {
        return a.label.localeCompare(b.label)
      })

      setHierarchies(dataSorted)
    } catch (err) {
      console.log(err)

      toast.error(
        'Houve um erro ao buscar as categorias. Tente novamente mais tarde!',
      )

      setHierarchies([])
    } finally {
      setHierarchyIsLoading(false)
    }
  }, [])

  async function handleSendToStore() {
    setIsSendStoreLoading(true)

    try {
      await LeroyMerlinService.sendFile(fileSelected, selectedAccountKey)

      onClose()
      resetProducts()

      Swal.fire({
        title: 'Sucesso!',
        text: 'Sua planilha foi enviada com sucesso, confira o resultado na loja!',
        icon: 'success',
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Houve um erro ao enviar o arquivo!')
    } finally {
      setIsSendStoreLoading(false)
    }
  }

  function handleSelectFileExcel(e) {
    if (e.target.files.length > 0) {
      const file = e.target.files[0]

      if (
        file.type !==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        toast.error('Arquivo inválido! Selecione um arquivo .xlsx')

        return
      }

      setFileSelected(file)
    }
  }

  function handleClickOnInput() {
    const input = document.getElementById('input-select-product')

    input.click()
  }

  async function handleGenerateExcelFile() {
    for (const product of productsToExport) {
      if (!product.GTIN) {
        return toast.error(
          `O produto com SKU ${product.SKU} está sem EAN, preencha e tente novamente!`,
        )
      }
    }

    const codProducts = productsToExport.map((prod) => prod.CODPRODUTO)

    setIsButtonGenerateFileLoading(true)

    try {
      await LeroyMerlinService.generateExcelFile(codProducts, hierarchySelected)

      linkDownloadRef.current?.click()
    } catch (error) {
      toast.error('Houve um erro ao gerar o arquivo!')
    } finally {
      setIsButtonGenerateFileLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) {
      getAccounts()

      if (selectedAccountKey !== '' && productsToExport.length > 0) {
        getHierarchies(selectedAccountKey)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHierarchies, isOpen, selectedAccountKey])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="modal-expleroy-dialog"
      contentClassName="modal-expleroy-content"
    >
      <Modal.Header closeButton>
        <Modal.Title>Exportar Produtos para Leroy Merlin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Selecione sua conta da Leroy:</p>
        <Form.Select
          className="mb-2"
          value={selectedAccountKey}
          onChange={(e) => {
            setSelectedAccountKey(e.target.value)
          }}
        >
          <option value="">Selecione sua conta</option>

          {accounts.map((account) => (
            <option
              key={Math.random()}
              value={account.TOKEN}
            >
              {account.NOME_CONTA}
            </option>
          ))}
        </Form.Select>

        {hierarchyIsLoading ? (
          <div
            style={{
              display: 'flex',
              gap: '5px',
            }}
          >
            <CustomSpinner size={22} />
            <p>Carregando categorias...</p>
          </div>
        ) : productsToExport.length <= 0 ? (
          <p>Sem Produtos Selecionados!</p>
        ) : (
          <>
            {selectedAccountKey !== '' && (
              <>
                <p>Selecione uma categoria para exportar os produtos:</p>

                <Select
                  className="form-control"
                  value={hierarchySelected}
                  onChange={setHierarchySelected}
                  placeholder="Selecione uma categoria"
                  options={hierarchies}
                />
              </>
            )}

            <div className="mt-4">
              <p>Produtos selecionados:</p>

              <section className="show-product">
                {productsToExport.map((product) => (
                  <ProductCard
                    key={product.CODPRODUTO}
                    product={product}
                  />
                ))}
              </section>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <CustomButton
          ref={generateFileButtonRef}
          isLoading={isButtonGenerateFileLoading}
          isDisabled={!hierarchySelected}
          title="Gerar Arquivo Excel"
          color="#7006d4"
          onClick={handleGenerateExcelFile}
        >
          <FiletypeXlsx size={24} />
        </CustomButton>

        <CustomButton
          title={
            fileSelected
              ? `Arquivo selecionado: ${fileSelected.name}`
              : 'Selecionar Arquivo Excel'
          }
          isDisabled={!selectedAccountKey}
          onClick={handleClickOnInput}
        >
          <HandIndexThumbFill size={24} />
        </CustomButton>

        <CustomButton
          title="Enviar para loja"
          color=" #045100 "
          isLoading={isSendStoreLoading}
          isDisabled={!fileSelected || !selectedAccountKey}
          onClick={handleSendToStore}
        >
          <Shop size={24} />
        </CustomButton>

        <a
          ref={linkDownloadRef}
          target="_blank"
          href={`${process.env.REACT_APP_BACKEND_API}/downloads/products_export_leroy_merlin.xlsx`}
          rel="noreferrer"
          style={{ display: 'none' }}
        ></a>

        <input
          id="input-select-product"
          accept=".xlsx"
          type="file"
          onChange={handleSelectFileExcel}
          style={{
            display: 'none',
          }}
        />
      </Modal.Footer>
    </Modal>
  )
}
